export enum FeatureFlagKeys {
  featurePushConsoleLogsToKibana = 'feature-push-console-logs-to-kibana',
  reconnectSoftphoneIfOutboundCallFails = 'reconnect-softphone-if-outbound-call-fails',
  featureBillingReportDownload = 'feature-billing-report-download',
  featureWorkflowIvrMediaFileEnabled = 'feature-workflow-ivr-media-file-enabled',
  featureDisplayCampaignNameOnTaskAndToast = 'feature-display-campaign-name-on-task-and-toast',
  featureLogSoftphoneMfeConnectionInfo = 'feature-log-softphone-mfe-connection-info',
  featureLogSoftphoneConnectionInfoInterval = 'feature-log-softphone-connection-info-interval',
  featureWebphoneNetworkTest = 'feature-webphone-network-test',
  // This flag is not in kebab-case due to inconsistency in LD flag naming conventions on the LD platform.
  // The flag is named "RTC-Webphone-EnableCallConnectionMonitoring" instead of "rtc-webphone-enable-call-connection-monitoring".
  // eslint-disable-next-line local-rules/require-kebab-case-feature-flags
  rtcWebphoneEnableCallConnectionMonitoring = 'RTC-Webphone-EnableCallConnectionMonitoring',
  featureRefreshUserStatus = 'feature-refresh-user-status',
  featurePreventMultipleRegistrations = 'feature-prevent-multiple-registrations',
  featureRtcWebphoneHandlesFetchingJwt = 'feature-rtc-webphone-handles-fetching-jwt',
  featureInboxCallWarmTransfers = 'feature-inbox-call-warm-transfers',
  featureRequireSeatAndBillToTenant = 'feature-require-seat-and-bill-to-tenant',
  featureVoicemailEmails = 'feature-voicemail-emails',
  featureAbandonedCallReportDownload = 'feature-abandoned-call-report-download',
  featureGracefullyHandleMicrophoneDisconnect = 'feature-gracefully-handle-microphone-disconnect',
  featureDataIntegrationEnabled = 'feature-data-integration-enabled',
  featureManagerAssist = 'feature-manager-assist',
  featureInboxIncomingTransferTag = 'feature-inbox-incoming-transfer-tag',
  featureLiveCallCenterMonitoringPage = 'feature-live-call-center-monitoring-page',
  featureOutboundMonitoringTab = 'feature-outbound-monitoring-tab',
  featureAgentDailyStatsUiEnabled = 'feature-agent-daily-stats-ui-enabled',
  fixDisablePopUpOnClose = 'fix-disable-pop-up-on-close',
  featureLinkCallInMonolithToCustomerAndLocationWhenCreatingNewCustomer = 'feature-link-call-in-monolith-to-customer-and-location-when-creating-new-customer',
  featureGlobalRecordingOverridesEnabled = 'feature-global-recording-overrides-enabled',
  featureMonitorAndResetUserStatus = 'feature-monitor-and-reset-user-status',
  featureNetworkMonitoringEnabled = 'feature-network-monitoring-enabled',
  featureNetworkCompressionMonitoringEnabled = 'feature-network-compression-monitoring-enabled',
  featureLogUserStatusStuckInterval = 'feature-log-user-status-stuck-interval',
  featureAutoRefreshUserStatus = 'feature-auto-refresh-user-status',
  featureQueueRolloverTimeoutNotificationEnabled = 'feature-queue-rollover-timeout-notification-enabled',
  featureAbandonedCallFollowUps = 'feature-abandoned-call-follow-ups',
  featureSecondChanceLeadFollowUps = 'feature-second-chance-lead-follow-ups',
  featureVirtualAssistantFollowUps = 'feature-virtual-assistant-follow-ups',
  featureVoicemailFollowUps = 'feature-voicemail-follow-ups',
  featureVmBoxAssignments = 'feature-vmbox-assignments',
  featureManageAccounts = 'feature-manage-accounts',
  featureVirtualAgentConfiguration = 'feature-virtual-agent-configuration',
  featureRecordingDefaultsConfiguration = 'feature-recording-defaults-configuration',
  featureVirtualAssistantJobBooking = 'feature-virtual-assistant-job-booking',
  featureShowOpenCallsInConversationHistory = 'feature-show-open-calls-in-conversation-history',
  featureShowOutboundCallsRecordingInConversationHistory = 'feature-show-outbound-calls-recording-in-conversation-history',
  featureEnableDeleteQueue = 'feature-enable-delete-queue',
  featureHelpCenter = 'feature-help-center',
  featureSendReportToDebugService = 'feature-send-report-to-debug-service',
  featureBulkUserActions = 'feature-bulk-user-actions',
  featureOfflineOnClose = 'feature-offline-on-close',
  featureCallTimeoutWarning = 'feature-call-timeout-warning',
  featureInboxCallTransferToQueue = 'feature-inbox-call-transfer-to-queue',
  featureGraphqlSubscriptionsEnabled = 'feature-graphql-subscriptions-enabled',
  featureFilterVaInConversationHistory = 'feature-filter-va-in-conversation-history',
  featureShowCallHandlingEventsInConversationHistory = 'feature-show-call-handling-events-in-conversation-history',
  featureQueueManagementPage = 'feature-queue-management-page',
  featureCallContinuity = 'feature-call-continuity',
  featureCallContinuityBanner = 'feature-call-continuity-banner',
  featureSpeedToLeadOutboundingV0 = 'feature-speed-to-lead-outbounding-v-0',
  featureSpeedToLeadOutboundingAiTaskOutcome = 'feature-speed-to-lead-outbounding-ai-task-outcome',
  featureEnableSoftphoneMfeDebugging = 'feature-enable-softphone-mfe-debugging',
  featureSequentialEventProcessing = 'feature-sequential-event-processing',
  enableDebugLogsToKibana = 'enable-debug-logs-to-kibana',
  featureAddUsersToRecordingExclusions = 'feature-add-users-to-recording-exclusions',
  featureShowQueueLongestWaitTime = 'feature-show-queue-longest-wait-time',
  featureWebphoneServerConnectionMonitoring = 'feature-webphone-server-connection-monitoring',
  featureVaDashboardMfe = 'feature-va-dashboard-mfe',
  featureCallTransferToTechnicians = 'feature-call-transfer-to-technicians',
  featureDisplayTechnicianConversationHistory = 'feature-display-technician-conversation-history',
  featureTransferOutboundToUserWithActivity = 'feature-transfer-outbound-to-user-with-activity',
  featureKeypadTransferOutboundToUserWithActivity = 'feature-keypad-transfer-outbound-to-user-with-activity',
  featureSpeedToLeadDemoCustomerPhoneNumber = 'feature-speed-to-lead-outbounding-v-0-demo',
  featureDisableSeatPromotion = 'feature-disable-seat-promotion',
  featureDisableQueueCreation = 'feature-disable-queue-creation',
  featureVoiceIntelligence = 'feature-voice-intelligence',
  featureQueueDrawerInfoPanel = 'feature-queue-drawer-info-panel',
  featureAudioDeviceManagement = 'feature-audio-device-management',
  featureClientServerTimeDiffRefreshIntervalMinutes = 'feature-client-server-time-diff-refresh-interval-minutes',
  featureUserActionEventBatchIntervalSeconds = 'feature-user-action-event-batch-interval-seconds',
  featureChDefaultDateFilter = 'feature-ch-default-date-filter',
  featurePictureInPicture = 'feature-picture-in-picture',
  featureRtcsDegradedQueueDetection = 'feature-rtcs-degraded-queue-detection',
  featureLiveServicesCallClaim = 'feature-live-services-call-claim',
  featurePauseInteractionCountPollingWhenHidden = 'feature-pause-interaction-count-polling-when-hidden',
  featureConfigureOutboundSettings = 'feature-configure-outbound-settings',
  featureOutboundTenantConfig = 'feature-outbound-tenant-config',
  featureDefaultCallerIdBanner = 'feature-default-caller-id-banner',
  featureDeactivateWarmTransferInteraction = 'feature-deactivate-warm-transfer-interaction',
  featureMultiPathEscalations = 'feature-multi-path-escalations',
  featureVaEscalationSummary = 'feature-va-escalation-summary',
  featureReduceInteractionUpdateRequests = 'feature-reduce-interaction-update-requests',
  featureShowQueueWarningInTransfer = 'feature-show-queue-warning-in-transfer',
  featureQueueCallback = 'feature-queue-callback',
  featureBypassAuthAgeCheck = 'feature-bypass-auth-age-check',
  featureCaptureExternalBridgeEventsForOutbound = 'feature-capture-external-bridge-events-for-outbound',
  featureHandleExternalCallEvents = 'feature-handle-external-call-events',
  featureRtcsSingleItemFetch = 'feature-rtcs-single-item-fetch',
  featureRtcsReconnectResync = 'feature-rtcs-reconnect-resync',
  // Navbar Anvil2 announcement for RTCS reconnecting / permanent loss (CCPE-2265).
  // Cleanup: CCPE-3169.
  featureRtcsConnectionStatusAnnouncement = 'feature-rtcs-connection-status-announcement',
  featureCheckCalleeStatusOnCall = 'feature-check-callee-status-on-call',
  featurePowerDialer = 'feature-power-dialer-v0',
  featureContactcenterAgentInboxTexting = 'feature-contactcenter-agent-inbox-texting',
  featureConfigurationReview = 'feature-configuration-review',
  featureViSettingsVisibility = 'feature-voice-intelligence-settings-visibility',
  enableVoiceIntelligenceCoachingHub = 'enable-voice-intelligence-coaching-hub',
  featureUseSipEventsForFailedTasks = 'feature-use-sip-events-for-failed-tasks',
  featureBookingFlowConfigAdminMfe = 'feature-booking-flow-config-admin-mfe',
  featureEnableAgentInboxForCalls = 'feature-enable-agent-inbox-for-calls',
  featureCoalesceAgentStatusUpdates = 'feature-coalesce-agent-status-updates',
  // Session/queue coalesce. Also requires featureCoalesceAgentStatusUpdates so
  // delayed sessions are not interleaved with immediate agent.status applies.
  featureCoalesceWorkspaceEvents = 'feature-coalesce-workspace-events',
  featureAgentLoginLogoutStatusSync = 'feature-agent-login-logout-status-sync',
  featureEnforceCoreRecordingTranscriptPermissions = 'feature-enforce-core-recording-transcript-permissions',
  // Mirrors the BFF flag of the same key: when on, resolving a voicemail
  // follow-up deletes the voicemail from the Kazoo mailbox.
  featureVoicemailResolveDeletesFromKazoo = 'feature-voicemail-resolve-deletes-from-kazoo',
  // Release flag for booking retention (CCPE-2665): ended outbound and external DID
  // call cards stay in WrapUp until the CSR closes them. Read only through
  // InboxModule.isBookingRetentionEnabled and useBookingRetentionEnabled.
  featureRetainEndedCallCards = 'feature-retain-ended-call-cards',
  // Customer lookups request a 3-location preview + total instead of every location.
  // Requires the BFF Customer.locations(first:) / locationCount fields.
  featureCustomerLocationsPreview = 'feature-customer-locations-preview',
  // Mirrors the BFF flag of the same key: when on, the voicemail follow-up
  // drawer shows the voicemail transcript.
  featureVoicemailTranscripts = 'feature-voicemail-transcripts',
  // Release flag for the new Assigned to Me column and manual bookings.
  // Read only through InboxModule.isNewAssignedToMeUiEnabled and useNewAssignedToMeUiEnabled,
  // which also require featureEnableAgentInboxForCalls and featureRetainEndedCallCards.
  featureAssignedToMeManualBookings = 'feature-assigned-to-me-manual-bookings',
}

/**
 * A set of all valid FeatureFlagKeys in LD (in kebab-case, generally)
 */
const AllFeatureFlagKeys = new Set(Object.values(FeatureFlagKeys));

/**
 * Checks if a key is a valid FeatureFlagKeys.
 * @param key - the key to check
 * @returns true if the key is a valid, registered member of FeatureFlagKeys, false otherwise
 */
export const isValidFeatureFlagKey = (key: string): key is FeatureFlagKeys => {
  return AllFeatureFlagKeys.has(key as FeatureFlagKeys);
};
